export default __webpack_public_path__ + "static/media/inappdynamics-logo.78193a6b.png";